import {
  Wheat, Shell, Egg, Fish, Nut, Sprout, Milk, Cherry, Carrot,
  Soup, Cookie, Wine, Flower2, Snail, CircleAlert,
} from "lucide-react";

export const ALLERGEN_ICONS = {
  gluten: Wheat,
  crustaceans: Shell,
  eggs: Egg,
  fish: Fish,
  peanuts: Nut,
  soybeans: Sprout,
  milk: Milk,
  nuts: Cherry,
  celery: Carrot,
  mustard: Soup,
  sesame: Cookie,
  sulphites: Wine,
  lupin: Flower2,
  molluscs: Snail,
};

export const allergenIcon = (code) => ALLERGEN_ICONS[code] || CircleAlert;
